<i18n lang="yaml">
  fr:
    title: Blog
    description: Retrouvez nos articles explorant les nombreux avantages à l'utilisation d'un thermostat connecté.
    read-more: Lire l'article
</i18n>

<template>
  <page-section>
    <default-hero :title="$t('title')" />
    <div class="grid">
      <div v-for="article in articles" :key="article.link"
        class="grid__row grid__row--center space-mb-4 grid__push-1--s"
        :class="[ $mq.isOneOf('xxs xs') ? 'type-align-center' : '' ]">

        <!-- Image -->
        <div
          class="'grid__col-12--xxs grid__col-3--s grid__col-left--s"
          :class="[ $mq.isOneOf('xxs xs') ? 'space-mb-2' : '' ]">
          <nuxt-link :to="`/blog/${article.slug}`">
            <img :src="`${article.image}`" />
          </nuxt-link>
        </div>

        <!-- Title and content preview -->
        <div class="grid__col-12--xxs grid__col-7--m">
          <nuxt-link :to="`/blog/${article.slug}`">
            <h3
              class="type-title-secondary type-weight-700 space-mb-3"
              v-html="coloredTitle(article.title)"></h3>
          </nuxt-link>

          <p class="body space-mb-4" v-html="article.description"></p>

          <nuxt-link
            :to="`/blog/${article.slug}`"
            class="btn btn--secondary btn--width-auto-xs space-mx-2--xs space-mx-0--s"
            :class="[ $mq.isOneOf('xxs xs') ? 'btn--width-afull-xxs' : '' ]">{{ $t('read-more') }}</nuxt-link>
        </div>
      </div>
    </div>
  </page-section>
</template>


<script>
  import DefaultHero from '~/components/DefaultHero';
  import PageSection from '~/components/CMS/PageSection';

  export default {
    components: {
      DefaultHero,
      PageSection,
    },

    nuxtI18n: {
      locales: [ 'fr' ],
      paths: {
        fr: '/blog',
      },
    },

    head() {
      return {
        title: 'Ween | ' + this.$t('title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('description'),
          },
        ],
      };
    },

    methods: {
      coloredTitle(title) {
        const [firstWord, ...otherWords] = title.split(' ');
        // eslint-disable-next-line max-len
        return `<span class="color-green">${firstWord}</span> ${otherWords.join(' ')}`;
      },
    },

    async asyncData({ app }) {
        const articles = await app.$content('fr/blog').sortBy('position', 'desc').fetch();
        return { articles: articles };
    },
  };
</script>
